"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LFCContext = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _LFCProvider = _interopRequireDefault(require("./LFCProvider.proptypes"));
var _constant = _interopRequireDefault(require("./constant"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LFCContext = /*#__PURE__*/(0, _react.createContext)();
exports.LFCContext = LFCContext;
var LFCProvider = function LFCProvider(props) {
  var children = props.children,
    departStation = props.departStation,
    arrivalStation = props.arrivalStation,
    endDate = props.endDate,
    currency = props.currency,
    airlineProfile = props.airlineProfile,
    date = props.date,
    range = props.range,
    beginDate = props.beginDate,
    isDestinationCity = props.isDestinationCity,
    isOriginCity = props.isOriginCity,
    environment = props.environment,
    getData = props.getData,
    channelHash = props.channelHash,
    userType = props.userType,
    authToken = props.authToken,
    domain = props.domain,
    getError = props.getError;
  var apiUrl = _constant.default[environment.toUpperCase()].LFC_API_URL.replace('{domain}', domain);
  var paramObj = {
    departStation: departStation,
    arrivalStation: arrivalStation,
    endDate: endDate,
    currency: currency,
    airlineProfile: airlineProfile,
    date: date,
    range: range,
    beginDate: beginDate,
    isDestinationCity: isDestinationCity,
    isOriginCity: isOriginCity
  };
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    lowFares = _useState2[0],
    setLowFares = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    errors = _useState4[0],
    setErrors = _useState4[1];
  var createParams = function createParams() {
    if (!paramObj || JSON.stringify(paramObj) === JSON.stringify({})) {
      return;
    }
    var queryParams = '';
    // eslint-disable-next-line no-restricted-syntax
    for (var key in paramObj) {
      // eslint-disable-next-line no-prototype-builtins
      if (paramObj.hasOwnProperty(key) && paramObj[key]) {
        queryParams += "".concat(key, "=").concat(paramObj[key], "&");
      }
    }
    queryParams = queryParams.substring(0, queryParams.length - 1);
    // eslint-disable-next-line consistent-return
    return queryParams;
  };
  var formatUrl = function formatUrl(url) {
    var params = createParams();
    if (!params) {
      return url;
    }
    return "".concat(url, "?").concat(params);
  };
  var getLowFares = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var url, headers, response;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            url = formatUrl(apiUrl);
            headers = {
              channel_hash: channelHash,
              'User-Type': userType,
              Authorization: "Bearer ".concat(authToken)
            };
            _context.prev = 2;
            _context.next = 5;
            return _utilities.default.get(url, headers);
          case 5:
            response = _context.sent;
            setLowFares(response);
            setErrors(null);
            if (getData) getData(response);
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            setErrors(_context.t0);
            if (getError) getError(_context.t0);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11]]);
    }));
    return function getLowFares() {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    getLowFares();
  }, [departStation, arrivalStation, endDate, currency, airlineProfile, date, range, beginDate, environment, channelHash, userType, authToken, isDestinationCity, isOriginCity]);
  return /*#__PURE__*/_react.default.createElement(LFCContext.Provider, {
    value: {
      lowFares: lowFares,
      errors: errors
    }
  }, children);
};
LFCProvider.propTypes = _LFCProvider.default.PropTypes;
LFCProvider.defaultProps = _LFCProvider.default.DefaultProps;
var _default = LFCProvider;
exports.default = _default;